module.exports = __webpack_public_path__ + "static/media/logo.fc98f046.png";